import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { StyledCard } from './style';
import routes from '../../../../routes';
import Icon from '../../Icon';
import Text from '../../Text';
import CTA from '../../CTA';
import { withMediaQueries } from '../../../../app/hoc/withMediaQueries';

const CardCoursesNone = ({ mediaIsPhone }) => {
  const navigate = useNavigate();

  return (
    <StyledCard>
      <div>
        <Icon
          type="graduation-hat-01"
          size={mediaIsPhone ? 40 : 48}
          stroke="#22408B"
          strokeWidth={1}
        />
        <div>
          <Text type="b4" color="#010101">
            Non hai ancora attivato dei corsi.
          </Text>
          <Text type="b4" color="#010101">
            Sfoglia il catalogo dei corsi e inizia un percorso di formazione.
          </Text>
        </div>
      </div>
      <div>
        <CTA
          type="primary"
          btnText="Vai alla formazione"
          onClick={() => navigate(`${routes.catalog.path}/nazionale`)}
        />
      </div>
    </StyledCard>
  );
};

CardCoursesNone.propTypes = {
  mediaIsPhone: PropTypes.bool,
};

export default withMediaQueries(CardCoursesNone);
